import { render, staticRenderFns } from "./html01.vue?vue&type=template&id=a9fb969a&scoped=true"
import script from "./html01.vue?vue&type=script&lang=js"
export * from "./html01.vue?vue&type=script&lang=js"
import style0 from "./html01.vue?vue&type=style&index=0&id=a9fb969a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fb969a",
  null
  
)

export default component.exports